import React from "react";
import { Container, Row, Col } from "reactstrap";

class Loader extends React.Component {
  render() {
    return (
      <div className={`loader ${(this.props.active ? 'loader--active' : '')} ${this.props.className}`}>
        {this.props.children}

        <div className="loader__spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }
}

export default Loader;
